$(document).ready(function () {
    
    var visualBoxSliderOptions = {
        "default" : {
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
            responsive: [
                {
                    breakpoint:  1200,
                    settings: {
                        variableWidth: false,
                    }
                },
                {
                    breakpoint:  768,
                    settings: {
                        variableWidth: true,
                    }
                }
            ]
        }
    }


    $(".js-sliderGallery").each(function() {

        let $slider = $(this);
        if ($slider.hasClass("initialized")) return;

        let sliderType = $slider.attr('data-slider');

        if (!sliderType) sliderType = "default";
        $slider.slick(visualBoxSliderOptions[sliderType]);

        let counterLi = $slider.find(".slick-dots li").length;
        let widthLi =  100 / counterLi +'%';
        $slider.find(".slick-dots li").css('width',widthLi);

        $slider.addClass("initialized");

    });


    $(".js-award__sliderNav .nav li.nav-item a").on("click", function (event) {
        selectCorrectTabPane(event)
    })

    $(".js-award__sliderNav .nav li.nav-item a").on('keydown', function(event) {
        if (event.key === "Enter" || event.keyCode === 13) {
            this.click()
        }
    });

    function selectCorrectTabPane(event) {
        let $indexContentToShow = $(event.currentTarget).attr("data-index");
        let $awardGallery = $(event.currentTarget).closest(".award__gallery");
        $awardGallery.find(".nav-item").find(".nav-link").removeClass("active");
        $(event.currentTarget).addClass("active");

        $awardGallery.find(".tab-content").find(".tab-pane").removeClass("show").removeClass("active");
        $awardGallery.find(".tab-content").find('.tab-pane[data-index="' + $indexContentToShow + '"]').addClass("show active");

        $awardGallery.find(".tab-content").find('.tab-pane[data-index="' + $indexContentToShow + '"]').find(".js-sliderGallery").slick("destroy");

        let sliderType = $awardGallery.find(".tab-content").find('.tab-pane[data-index="' + $indexContentToShow + '"]').find(".js-sliderGallery").attr('data-slider');
        if (!sliderType) sliderType = "default";
        $awardGallery.find(".tab-content").find('.tab-pane[data-index="' + $indexContentToShow + '"]').find(".js-sliderGallery").slick(visualBoxSliderOptions[sliderType]);

        let counterLi = $awardGallery.find(".tab-content").find('.tab-pane[data-index="' + $indexContentToShow + '"]').find(".js-sliderGallery").find(".slick-dots li").length;
        let widthLi =  100 / counterLi +'%';
        $awardGallery.find(".tab-content").find('.tab-pane[data-index="' + $indexContentToShow + '"]').find(".js-sliderGallery").find(".slick-dots li").css('width',widthLi);
    }

});
